// src/components/mediaConversion/MediaConversionPanel/encodingMeta.ts

import type { EncodingStageKey } from "../../../types/mediaConversion/encoding";

export const ENCODING_STAGE_META: Record<
  EncodingStageKey,
  { label: string; hint: string }
> = {
  "1080p": {
    label: "1080p",
    hint: "Best quality (may take longer)",
  },
  "720p": {
    label: "720p",
    hint: "Balanced quality",
  },
  "480p": {
    label: "480p",
    hint: "Mobile friendly (fastest)",
  },
};
